export default __webpack_public_path__ + "static/media/New-Booking.18c8501c.svg";